import React from 'react'
import { Link } from 'react-router'

const SrServices = () => {
  return (
    <>
          <div className="service innar-service pt-125 ">
            <div className="container">
                <div className="row mt-none-30">
                    <div className="col-lg-6 mt-30">
                        <div className="section-title">
                            <span className="sub-title wow fadeInRight" data-wow-duration=".7s">Core Services</span>
                            <h3 className="title xb-split-text split-in-right mb-60">Discover Our <br/> <span>Capabilities</span></h3>
                        </div>
                        <p className="xb-item--content">
                            Our Digital Marketing services are a complete bouquet of targeted, measurable, and interactive tools to market products or services of Startups and Brands.<br/>
                            Our marketing services include Internet marketing techniques, such as search engine optimisation (SEO), search engine marketing (SEM) & link building, Social media optimisation (SMO), social media marketing (SMM), display advertising, email marketing, e-books and many other forms of digital media.
                            </p>
                    </div>
                    <div className="col-lg-6 mt-30">
                        <div className="row mt-none-60">
                            <div className="col-md-6 mt-60">
                                <div className="xb-service pos-rel">
                                    <div className="xb-item--icon">
                                        <img src="assets/img/icon/sv_01.svg" alt=""/>
                                    </div>
                                    <h3 className="xb-item--title">Digital Marketing</h3>
                                    <p className="xb-item--content">
                                        Driving growth with data-driven strategies that connect you to your audience effectively.
                                        </p>
                                    <div className="xb-item--arrow"><i className="fal fa-arrow-down"></i></div>
                                    <Link className="xb-overlay" to="/digital-marketing"></Link>
                                </div>
                            </div>
                            <div className="col-md-6 mt-60">
                                <div className="xb-service pos-rel">
                                    <div className="xb-item--icon">
                                        <img src="assets/img/icon/sv_02.svg" alt=""/>
                                    </div>
                                    <h3 className="xb-item--title">Visual Branding</h3>
                                    <p className="xb-item--content">
                                        Creating impactful brand identities through striking visuals that leave a lasting impression.
                                    </p>
                                    <div className="xb-item--arrow"><i className="fal fa-arrow-down"></i></div>
                                    <Link className="xb-overlay" to="/visual-branding"></Link>
                                </div>
                            </div>
                            <div className="col-md-6 mt-60">
                                <div className="xb-service pos-rel">
                                    <div className="xb-item--icon">
                                        <img src="assets/img/icon/sv_03.svg" alt=""/>
                                    </div>
                                    <h3 className="xb-item--title">Web Development</h3>
                                    <p className="xb-item--content">
                                        Building responsive, high-performance websites to enhance your online presence.
                                    </p>
                                    <div className="xb-item--arrow"><i className="fal fa-arrow-down"></i></div>
                                    <Link className="xb-overlay" to="/web-development"></Link>
                                </div>
                            </div>
                            <div className="col-md-6 mt-60">
                                <div className="xb-service pos-rel">
                                    <div className="xb-item--icon">
                                        <img src="assets/img/icon/sv_04.svg" alt=""/>
                                    </div>
                                    <h3 className="xb-item--title">Social Media Management</h3>
                                    <p className="xb-item--content">Managing and optimizing your social channels to boost engagement and amplify your brand voice.
                                    </p>
                                    <div className="xb-item--arrow"><i className="fal fa-arrow-down"></i></div>
                                    <Link className="xb-overlay" to="/social-media-management"></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </>
  )
}

export default SrServices
